<template>
	<div style="min-width: 60px;">
		<!-- <v-menu v-model="menu" bottom center offset-y origin="top center" transition="scale-transition" :close-on-content-click="false">
			<template v-slot:activator="{ attrs, on }">
				<v-btn class="mt-n2 ml-n2" type="submit" fab small elevation="2" height="30" width="30" @click="menu=true">
					<v-icon>mdi-dots-horizontal</v-icon>
				</v-btn>
			</template>
</v-menu> -->

		<div v-if="!hideTypesBadge" v-for="t in types.filter(x => x.abbr)" :key="t.type + String(key)" @click="showOperation(t)" style="cursor: pointer;display: inline;margin-left: -6px;">
			<v-badge :color="getColor(t.type)" :title="t.title" :content="t.abbr + getCount(t.type)" inline>
			</v-badge>
		</div>

		<v-dialog v-model="operationDialog" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">عملیات مورد نظر را انتخاب کنید</span></div>
					<v-spacer />
					<v-btn @click="operationDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<div class="my-3 text-center">
							<v-btn width="200" color="secondary" dark :disabled="!selectedType.items.length" @click="showDetailsList">مشاهده جزئیات پیام ها</v-btn>
						</div>
						<div class="my-3 text-center">
							<v-btn width="200" color="success" dark @click="sendNewSms()" :loading="sendNewSmsLoading">ارسال پیامک {{ selectedType.title }} جدید</v-btn>
						</div>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="detailsDialog" scrollable persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست پیامک های {{ selectedType.title }}</span></div>
					<v-spacer />
					<v-btn @click="detailsDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-data-table dense :headers="headers" :loading="detailsListLoading" :items="detailsListItems" :items-per-page="15" class="elevation-1">
							<template v-slot:item.smsPanelText="{ item }">
								{{ translateSmsPanel(item.smsPanelText) }}
							</template>
							<template v-slot:item.statusText="{ item }">
								<div class="d-flex align-center" :class="[statusColor(item.statusText) + '--text']">
									<v-icon :color="statusColor(item.statusText)" small inline class="ml-1">
										{{ statusIcon(item.statusText) }}
									</v-icon>
									<span class="text-h6" style="white-space: nowrap;">{{ translateStatus(item.statusText) }}</span>
									<v-btn v-if="item.statusText === 'Pending' && item.smsKey" fab icon x-small @click="refreshStatus(item)" :loading="rowLoading == item.id">
										<v-icon>mdi-refresh</v-icon>
									</v-btn>
								</div>
							</template>
							<template v-slot:item.date_Persian="{ item }">
								<div>{{ item.date_Persian.date }}</div>
								<div>{{ item.date_Persian.time }}</div>
							</template>
							<template v-slot:item.text="{ item }">
								<div @click="showSmsMessage(item.text)" style="max-width:250px;overflow:hidden;cursor:pointer;text-overflow: ellipsis;white-space: nowrap;">
									{{ item.text }}
								</div>
							</template>
							<template v-slot:item.appSmsTypeText="{ item }">
								{{ translateType(item) }}
							</template>
							<template v-slot:item.price="{ item }">
								{{ item.price.toString().toPriceFormat() }}
							</template>
							<template v-slot:item.operations="{ item }">
								<v-btn small @click="resend(item)" :loading="rowLoading == item.id">
									ارسال مجدد
								</v-btn>
							</template>
						</v-data-table>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="smsMessageDialog" max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">متن پیامک</span></div>
					<v-spacer />
					<v-btn @click="smsMessageDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<p style="white-space: pre-wrap;">{{ smsMessage }}</p>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'AppSmsDetails',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		props: {
			data: {
				type: Array,
			},
			userLoanPaymentId: {
				type: String
			},
			type: {
				type: String
			},
			hideTypesBadge: {
				type: Boolean,
				default: false
			}
		},
		data: () => ({
			key: 1,
			menu: false,
			localData: [],
			detailsListItems: [],
			detailsListLoading: false,
			rowLoading: '',
			smsMessage: '',
			smsMessageDialog: false,
			sendNewSmsLoading: false,
			operationDialog: false,
			detailsDialog: false,
			selectedType: { title: '', items: [], type: '' },
			types: [{
				type: 'BeforeDueDate',
				title: 'پیش از موعد',
				abbr: 'پ'
			},
			{
				type: 'DueDate',
				title: 'سررسید',
				abbr: 'س'
			},
			{
				type: 'OverDueDate',
				title: 'معوق',
				abbr: 'م'
			},
			{
				type: 'Thanks',
				title: 'تشکر',
				abbr: 'ت'
			},
			{
				type: 'ChangeStatus',
				title: 'تغییر وضعیت درخواست',
				abbr: ''
			},
			{
				type: 'ChangeAgentStatus',
				title: 'تغییر وضعیت درخواست نماینده',
				abbr: ''
			}
			],
			headers: [
				{
					text: 'پنل پیامک',
					align: 'right',
					sortable: true,
					value: 'smsPanelText',
				},
				{
					text: 'وضعیت',
					align: 'center',
					sortable: true,
					value: 'statusText',
				},
				{
					text: 'زمان ارسال',
					align: 'center',
					sortable: true,
					value: 'date_Persian',
				}, {
					text: 'متن',
					align: 'right',
					sortable: true,
					value: 'text',
					width: 200
				}, {
					text: 'دریافت کننده',
					align: 'center',
					sortable: true,
					value: 'to',
				}, {
					text: 'نوع',
					align: 'center',
					sortable: true,
					value: 'appSmsTypeText',
				}, {
					text: 'عملیات',
					align: 'center',
					sortable: false,
					value: 'operations',
				}
			],
		}),
		watch: {
			data: {
				deep: true,
				handler(val) {
					this.localData = [...val]
					if (this.type !== 'ChangeStatus' && this.selectedType)
						this.selectedType.items = this.localData.filter(x => x.appSmsTypeText === this.selectedType.type)
					else if (this.type === 'ChangeStatus')
						this.selectedType.items = [...this.localData]
				}
			}
		},
		created() {
			this.localData = [...this.data]
			if (this.type === 'ChangeStatus') {
				this.selectedType = {
					type: 'ChangeStatus',
					title: 'تغییر وضعیت درخواست',
					items: [...this.localData]
				}
			}
		},
		methods: {
			getColor(type) {
				if (!this.localData?.filter(x => x.appSmsTypeText === type)?.length)
					return 'grey'
				if (this.localData?.filter(x => x.appSmsTypeText === type && x.statusText === 'Delivered')?.length > 0)
					return 'success'
				if (this.localData?.filter(x => x.appSmsTypeText === type && x.statusText === 'Pending')?.length > 0)
					return 'warning'
				return 'error'
			},
			getCount(type) {
				let count = this.localData?.filter(x => x.appSmsTypeText === type)?.length
				if (!count || count === 1)
					return ''
				return ` (${count})`
			},
			showOperation(type) {
				this.selectedType.title = type.title
				this.selectedType.type = type.type
				this.selectedType.items = this.localData.filter(x => x.appSmsTypeText === type.type)
				this.operationDialog = true
			},
			sendNewSms() {
				this.sendNewSmsLoading = true
				api.post('admin/appsms/SendForUserLoanPayment/?id=' + this.userLoanPaymentId + '&type=' + this.selectedType.type, null)
					.then(response => {
						toast.success('پیامک ارسال شد.')
						this.operationDialog = false
						this.localData.push(response)
						this.key++
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.sendNewSmsLoading = false
					})
			},
			loadSmsDetailsList() {
				this.detailsListLoading = true
				api.post('admin/appsms/ListByIds', { ids: this.selectedType.items.map(x => x.id) })
					.then(
						response => {
							this.detailsListItems = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.detailsListLoading = false
					})
			},
			translateType(item) {
				if (item.appSmsType == 0)
					return item.smsPatternTitle

				let translates = {
					'Unknown': 'متفرقه',
					'DueDate': 'یادآوری سررسید',
					'Thanks': 'تشکر از پرداخت',
					'OverDueDate': 'معوق',
					'BeforeDueDate': 'یادآوری پیش از موعد',
					'ChangeStatus': 'تغییر وضعیت مشتری',
					'ChangeAgentStatus': 'تغییر وضعیت نماینده',
				}
				return translates[item.appSmsTypeText] || 'نامشخص'
			},
			translateStatus(status) {
				let items = {
					'Pending': 'منتظر وضعیت',
					'Delivered': 'تحویل شده',
					'Failed': 'تحویل نشده',
				}
				return items[status] || 'نامشخص'
			},
			statusColor(status) {
				let items = {
					'Pending': 'warning',
					'Delivered': 'success',
					'Failed': 'error',
				}
				return items[status] || 'grey'
			},
			statusIcon(status) {
				let items = {
					'Pending': 'mdi-timer-sand',
					'Delivered': 'mdi-check-circle',
					'Failed': 'mdi-close-circle',
				}
				return items[status] || 'mdi-exclamation'
			},
			showSmsMessage(text) {
				this.smsMessage = text
				this.smsMessageDialog = true
			},
			async resend(item) {
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از ارسال مجدد این پیامک مطمئن هستید؟',
				)) {
					this.rowLoading = item.id
					api.post('admin/appsms/ReSend/' + item.id, null)
						.then(response => {
							toast.success('پیامک ارسال شد.')
							this.loadSmsDetailsList()
						})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(() => {
							this.rowLoading = ''
						})
				}
			},
			showDetailsList() {
				this.detailsListItems = []
				this.detailsDialog = true
				if (this.selectedType?.items.length)
					this.loadSmsDetailsList()
			},
			translateSmsPanel(panel) {
				let items = {
					'Unknown': 'نامشخص',
					'JetAqsaat_MelliPayamak': 'جت اقساط',
					'JetAqsaat_KaveNegar': 'جت اقساط',
					'JetAqsaat': 'جت اقساط',
					'MelliPayamak': 'ملی پیامک',
					'KaveNegar': 'کاوه نگار',
				}
				return items[panel] || 'نامشخص'
			},
			refreshStatus(item) {
				this.rowLoading = item.id
				api.post('admin/appsms/CheckStatus/' + item.id, null)
					.then(response => {
						item.statusText = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.rowLoading = ''
					})
			}
		}
	}
</script>
<style scoped>
	.detial-box .title {
		font-size: 11px;
		color: grey;
	}

	.detial-box .value {
		font-size: 11px;
		color: black;
	}
</style>